export default {
      id: "ic_info_neutral_filled-usage",
      viewBox: "0 0 36 36",
      url: "/" + "images/icons.3.109.2.svg#ic_info_neutral_filled-usage",
      toString: function () {
        return this.url;
      }
    }